export const DEFAULT_MUNICIPIO_CONFIG = {
  tribunal: 'TCEMG',
  municipio: 'BETIM',
  ano: 2024
};
